import { type IntegrationServiceId } from '../common/integrations'

export enum OnboardingFlowType {
  DEFAULT = 'default',
}

export enum DefaultOnboardingFlowStepId {
  CALENDAR_SOURCE = 'calendarSource',
  CONTACT_SOURCE = 'contactSource',
  FINANCIAL_PLANNING = 'financialPlanning',
  MAIL = 'mail',
  ZOOM = 'zoom',
}

export enum Capability {
  CALENDAR_SOURCE = 'calendarSource',
  CONTACT_SOURCE = 'contactSource',
  FINANCIAL_PLANNING = 'financialPlanning',
  MAIL = 'mail',
  ZOOM = 'zoom',
}

export enum OnboardingFlowStatus {
  NOT_STARTED = 'not_started',
  ACTIVE = 'active',
  COMPLETED = 'completed',
  DISMISSED = 'dismissed',
}

export enum OnboardingStepStatus {
  PENDING = 'pending',
  COMPLETED = 'completed',
  NOT_ALLOWED = 'not_allowed',
  SKIPPED = 'skipped',
}

export interface OnboardingStep {
  id: string
  status: OnboardingStepStatus
}

export interface OnboardingFlow {
  flowType: OnboardingFlowType
  status: OnboardingFlowStatus
  steps: OnboardingStep[]
}

export interface CapabilityState {
  isAllowed: boolean
  isFulfilled: boolean
  allowedServiceIds: IntegrationServiceId[]
  allowedSecondaryIds?: IntegrationServiceId[]
  connectedIntegrations: IntegrationServiceId[]
  connectedWithoutSync: IntegrationServiceId[]
}

export type Capabilities = Record<Capability, CapabilityState> & { isLoading: boolean }
